import { Tag } from 'components/Tags'
import * as React from 'react'
import { connect } from 'react-redux'
import { flyThemes, Theme } from '../../data/models/funnelOrder/theme'
import { SiteCountry } from '../../data/models/locale'
import { AppState } from '../../data/state'

interface AutoCityExcludesProps {
  country: SiteCountry
  theme: Theme
}

const AutoCityExcludes: React.FC<AutoCityExcludesProps> = ({
  country,
  theme,
}) => {
  if (flyThemes.includes(theme)) {
    switch (country) {
      case SiteCountry.nl:
        return (
          <>
            <Tag text="Benelux" disabled={true} />
          </>
        )
      case SiteCountry.ie:
      case SiteCountry.uk:
        return (
          <>
            <Tag text="Ireland" disabled={true} />
            <Tag text="United Kingdom" disabled={true} />
          </>
        )
    }
  }
  return null
}

const mapStateToProps = (state: AppState) => ({
  country: state.locale.country,
  theme: state.funnelOrder.theme,
})

export default connect(mapStateToProps)(AutoCityExcludes)
